var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestionOrange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100 0H0V100H100V0Z",
    fill: "#FCEBE3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6922 63.44H54.7722V62.504C54.7722 60.44 55.3482 58.64 56.5002 57.104C57.6522 55.568 58.9722 54.104 60.4602 52.712C61.6122 51.608 62.7162 50.48 63.7722 49.328C64.8282 48.128 65.6922 46.832 66.3642 45.44C67.0842 44 67.4442 42.368 67.4442 40.544C67.4442 38 66.7962 35.6 65.5002 33.344C64.2042 31.04 62.2602 29.168 59.6682 27.728C57.1242 26.24 53.9802 25.496 50.2362 25.496C47.1642 25.496 44.3802 26.072 41.8842 27.224C39.4362 28.376 37.4202 29.96 35.8362 31.976C34.3002 33.992 33.3162 36.344 32.8842 39.032L42.8922 41.552C43.1802 39.728 43.9722 38.288 45.2682 37.232C46.6122 36.128 48.1722 35.576 49.9482 35.576C52.0122 35.576 53.5722 36.08 54.6282 37.088C55.7322 38.048 56.2842 39.296 56.2842 40.832C56.2842 42.32 55.7322 43.64 54.6282 44.792C53.5242 45.896 52.2762 47.144 50.8842 48.536C49.3962 50.072 47.9802 51.872 46.6362 53.936C45.3402 56 44.6922 58.616 44.6922 61.784V63.44ZM44.4042 80H55.2042V69.2H44.4042V80Z",
    fill: "#F78670"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionOrange);
export default __webpack_public_path__ + "static/media/questionOrange.a22061008e086a4c7b669205e269e92e.svg";
export { ForwardRef as ReactComponent };